import Vue from 'vue';
export const getters = {
  getPowerSumValues(state) {
    return state.aggregationData?.powerSumValues || [];
  },
  getTypeSumValues(state) {
    return state.aggregationData?.typeSumValues || [];
  },
  getTotalCost(state) {
    return state.aggregationData?.totalCost || 0;
  },
  getTotalPower(state) {
    return state.aggregationData?.totalPower || 0;
  },
  getTagTotalCost(state) {
    return state.tagTotal?.TotalCost || 0;
  },
  getTagTotalPower(state) {
    return state.tagTotal?.TotalPower || 0;
  },
  getTagTotalOfSelectedView(state, getters, rootState, rootGetters) {
    const { tagTotal } = state;
    let { activeTagName: tag } = rootState.ScheduleViews;
    const { canSelectedViewTriggerTotalTag } = getters;

    // View that is filtered to a specific tag.
    if (!tag) {
      const selectedView = rootGetters['ScheduleViews/selectedView'];
      if (selectedView?.filterTag?.length === 1) {
        tag = selectedView.filterTag[0];
      }
    }

    if (!tagTotal || !canSelectedViewTriggerTotalTag || !tag) {
      return false;
    }
    const { TotalPower: power, TotalCost: cost } = tagTotal;
    const isSelectedProjectBudgetView = rootGetters['ScheduleViews/isSelectedProjectBudgetView'];
    const isSelectedSustainabilityView = rootGetters['ScheduleViews/isSelectedSustainabilityView'];
    if (isSelectedSustainabilityView) {
      return `${power} (Watts)`;
    } else if (isSelectedProjectBudgetView) {
      return Vue.prototype.$formatCurrency(Math.abs(cost));
    }
  },
  canSelectedViewTriggerTotalTag(state, getters, rootState, rootGetters) {
    const selectedViewName = rootGetters['ScheduleViews/selectedViewName'];
    if (!selectedViewName) {
      return false;
    }
    const canTrigger = rootGetters['ScheduleViews/isSelectedSustainabilityView']
      || rootGetters['ScheduleViews/isSelectedProjectBudgetView'];
    return canTrigger;
  },
};
